import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  asset: belongsTo('asset', { inverse: 'assetFormatRelations' }),
  assetFormat: belongsTo('asset-format', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
});
